// extracted by mini-css-extract-plugin
export default {"submitBtn":"additional-info-and-attachments-form_submitBtn__Go4a+"};